import useUrlListParams from '../../../../hooks/useUrlListParams';
import { MANAGED_DROP_REVIEW_STATUSES } from '../managedDropReviewFormatting';

const isReviewStatus = (status: string) =>
  (MANAGED_DROP_REVIEW_STATUSES as readonly string[]).includes(status);

/**
 * URL state of the Drop review queue: page, search and the status filter. No
 * filter means pending and history together, which is what the queue answers
 * when it is asked for nothing in particular. A state the queue does not admit
 * — `creating`, `creation_failed` — is dropped rather than sent: the server
 * would answer `invalid_request`, and the admin would be looking at an error
 * instead of a queue.
 */
const useManagedDropReviewParams = () => {
  const params = useUrlListParams();

  return {
    ...params,
    statuses: params.readSet('status', isReviewStatus),
    toggleStatus: (status: string) =>
      params.toggleInSet('status', status, isReviewStatus),
  };
};

export default useManagedDropReviewParams;
